import React from 'react';
import '../assets/css/base.css';
import '../assets/css/login.css';
import Axios from 'axios';
import {Redirect}from 'react-router-dom';
import ptitle from '../assets/images/why191108_login_title.png'
class Login extends React.Component{
  
  constructor(props){
   super(props)
  }
  state={
    name:"",
    regionId:"",
    loginFlag:false,
    //domain:'http://10.0.7.102:3005',
    domain:"",
    regionIdMd:""
}
requestData=(id)=>{
    console.log(id);
  
 }

 dologin=()=>{    
    var username= this.refs.username.value;
    var password = this.refs.userpwd.value;
    var api=this.state.domain+"/switch/login/do";
     if(username===''||password===''||username===undefined||password===undefined) {
          alert("账号或密码不能为空！")
          return;
     } 
     var  params = new URLSearchParams();
     params.append("username",username);
     params.append("password",password);
    Axios.post(api,params)
     .then((res)=>{
          localStorage.clear();
         //把用户id 和区域id  区域名字 插入内存   
          localStorage.setItem("regionName",res.data.data.regionName);
          localStorage.setItem("regionId",res.data.data.regionId);
          localStorage.setItem("loginUserName",username);
          localStorage.setItem("userId",res.data.data.userId);
          localStorage.setItem("regionIdMd",res.data.data.regionIdMd);
          localStorage.setItem("countyId",res.data.data.countyId);
          localStorage.setItem("countyName",res.data.data.countyName);
           //设置默认选中栏
         localStorage.setItem("key","1");
        if(res.data.status===1){
          this.setState({
            loginFlag:true,
            regionIdMd:res.data.data.regionIdMd,        
        })    
        }else{
          console.log(res.data.message);
          alert(res.data.message);
          return;     
        }
     })
    .catch((error)=>{
        console.log(error)
    })   
}
  render(){
    if(this.state.loginFlag){
        return <Redirect to={{pathname: `/login/${this.state.regionIdMd}`} }/>;
      };
    return(
        <div>
           <div className="why_login">
              <div className="login_con">
                  <img className="login_title" src={ptitle} alt="表头图"/>
                    <div className="login_content">
                      <div className="login_form" >
                          <p className="login_user"><input type="text" className="username" id="username" ref="username" placeholder="输入账号"/><span></span></p>
                            <p className="login_pwd"><input type="password" className="userpwd" id="userpwd" ref="userpwd" placeholder="输入密码"/><span></span></p>
                          <p className="login_btn"><button  id="userbtn" onClick={this.dologin}>登录</button></p>
                        </div>
                    </div>
                </div>
          </div>
        </div>
    )
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/components/Login.js